'use client'
import {
  useAuth
} from "./chunk-ZF2ENNTR.mjs";
import {
  __async
} from "./chunk-BTG5EALA.mjs";

// src/components/logout/LogoutModal.tsx
import { Button, Modal } from "@wbk/ui";
import { useLogout } from "@wbk/api/hooks";
import { useRouter, useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var LogoutModal = ({ render, onClosed }) => {
  const { locale } = useRouter();
  const { clearTokens } = useAuth();
  const { t } = useTranslation(["auth_common"]);
  const { mutateAsync, isPending } = useLogout({ lang: locale });
  const onConfirm = (close) => __async(void 0, null, function* () {
    try {
      yield mutateAsync();
      clearTokens();
      close();
      if (onClosed) {
        onClosed();
      }
    } catch (error) {
    }
  });
  return /* @__PURE__ */ jsx(
    Modal,
    {
      render,
      body: ({ close }) => /* @__PURE__ */ jsxs("div", { className: "p-4", children: [
        /* @__PURE__ */ jsx("div", { className: "mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-600/30 text-white opacity-50", children: /* @__PURE__ */ jsx(
          "svg",
          {
            className: "h-10 w-10",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "aria-hidden": "true",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.2",
                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx("p", { className: "my-6 text-center text-xl", children: t("auth_common:confirm_logout") }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-baseline justify-evenly gap-4", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              "data-testid": "auth_cancel_logout",
              onClick: close,
              shape: "outlined",
              theme: "white",
              className: "w-full",
              disabled: isPending,
              children: t("auth_common:cancel")
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              "data-testid": "auth_logout",
              theme: "error",
              className: "w-full uppercase",
              onClick: () => {
                onConfirm(close);
              },
              loading: isPending,
              children: t("auth_common:logout")
            }
          )
        ] })
      ] })
    }
  );
};
var LogoutModal_default = LogoutModal;

export {
  LogoutModal_default
};
//# sourceMappingURL=chunk-NV5KTRL3.mjs.map